import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateProductList = {
  productList: { data: null, loading: false, error: null },
};

export const productList = createAsyncThunk('user/productList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/product/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerProductList = {
  [productList.pending]: (state) => {
    state.productList.loading = true;
  },
  [productList.fulfilled]: (state, action) => {
    state.productList.loading = false;
    state.productList.data = action.payload;
    state.productList.error = null;
  },
  [productList.rejected]: (state, action) => {
    state.productList.data = null;
    state.productList.loading = false;
    state.productList.error = action.payload;
  },
};
